import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import ActionDialog from '../globalModals/ActionDialog';
import type { ActionType } from '../globalModals/ActionDialog';

interface RecoveryFailureDialogProps {
  onClose: () => void;
}

const RecoveryFailureDialog: React.FC<RecoveryFailureDialogProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const dialogActions: ActionType[] = [
    {
      key: 'understand',
      label: t('common.done'),
      onClick: onClose,
      variant: 'contained',
      color: 'primary',
    },
  ];

  return (
    <ActionDialog
      open
      title={t('recovery.failure.title')}
      onClose={onClose}
      actions={dialogActions}
      maxWidth="xs"
    >
      <div className="text-center py-2">
        <div className="mb-4">
          <AlertTriangle className="w-12 h-12 text-amber-500 mb-3 mx-auto" />
        </div>

        <h3 className="text-lg font-medium mb-4">
          {t('recovery.failure.noDataTitle')}
        </h3>

        <p className="text-muted-foreground mb-4">
          {t('recovery.failure.noDataDescription')}
        </p>

        <div className="bg-muted rounded-lg p-4 text-left">
          <p className="text-sm font-semibold mb-2">
            {t('recovery.failure.quickTips')}
          </p>
          <p className="text-sm text-muted-foreground mb-1">
            {t('recovery.failure.tips.recordTime')}
          </p>
          <p className="text-sm text-muted-foreground mb-1">
            {t('recovery.failure.tips.internet')}
          </p>
          <p className="text-sm text-muted-foreground">
            {t('recovery.failure.tips.permissions')}
          </p>
        </div>
      </div>
    </ActionDialog>
  );
};

export default RecoveryFailureDialog;
